import React from 'react';
import { humanizeKey, humanizeValue, valuesAreEqual } from '../../profile-explanation-utils';

interface IDefaultVsResolvedTableProps {
    defaultData: Record<string, unknown>;
    resolvedData: Record<string, unknown>;
}

const DefaultVsResolvedTable: React.FC<IDefaultVsResolvedTableProps> = ({ defaultData, resolvedData }) => {
    const defaultObj = defaultData ?? {};
    const resolvedObj = resolvedData ?? {};
    const allKeys = Array.from(new Set([...Object.keys(defaultObj), ...Object.keys(resolvedObj)]));
    if (allKeys.length === 0) return null;
    
    return (
        <table className="profile-explanation-default-resolved-table">
            <thead>
                <tr>
                    <th className="profile-explanation-dr-col-property">Property</th>
                    <th className="profile-explanation-dr-col-default">Default value</th>
                    <th className="profile-explanation-dr-col-resolved">Computed value</th>
                </tr>
            </thead>
            <tbody>
                {allKeys.map((k) => {
                    const dVal = k in defaultObj ? defaultObj[k] : undefined;
                    const rVal = k in resolvedObj ? resolvedObj[k] : undefined;
                    const isChanged = !valuesAreEqual(dVal, rVal);
                    return (
                        <tr key={k} className={isChanged ? 'profile-explanation-row-changed' : ''}>
                            <td className="profile-explanation-dr-col-property">{humanizeKey(k)}</td>
                            <td className="profile-explanation-dr-col-default">
                                {k in defaultObj ? humanizeValue(defaultObj[k]) : '\u2013'}
                            </td>
                            <td className="profile-explanation-dr-col-resolved">
                                {k in resolvedObj ? humanizeValue(resolvedObj[k]) : '\u2013'}
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

export default DefaultVsResolvedTable;
